import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

interface StatusTagProps {
  status: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  switch (status) {
    case 'success':
      return (
        <Tag color="green" icon={<CheckCircleOutlined />}>
          Success
        </Tag>
      );
    case 'failed':
      return (
        <Tag color="red" icon={<CloseCircleOutlined />}>
          Failed
        </Tag>
      );
    case 'pending':
      return (
        <Tag color="orange" icon={<ClockCircleOutlined />}>
          Pending
        </Tag>
      );
    case 'draft':
      return <Tag color="blue">Saved</Tag>;
    default:
      return <Tag color="default">{status}</Tag>;
  }
};

